import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delayMs`. Rapid changes are coalesced — only the
 * value that stays put for the whole delay is emitted.
 *
 * A `delayMs` of 0 still defers by one timer tick, which keeps the emitted value
 * out of the same render pass.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
